import { render } from "./CashPayments.vue?vue&type=template&id=d493fe0a&scoped=true"
import script from "./CashPayments.vue?vue&type=script&lang=js"
export * from "./CashPayments.vue?vue&type=script&lang=js"

import "./CashPayments.vue?vue&type=style&index=0&id=d493fe0a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d493fe0a"]])

export default __exports__